// 报错Error类型定义

// 前端输入参数校验失败
export class ParamError extends Error {
    constructor(message) {
        super(message);

        this.errorType = "ParamError";
    }
}

// 服务端返回错误
export class ServerRespError extends Error {
    constructor(message) {
        super(message);

        this.errorType = "ServerRespError";
    }
}
